import type {
  AlgoliaProduct,
  JaneSearchState,
  RangeFilterValue,
} from '@jane/search/types';

export const selectedFilterRange = (
  searchState: JaneSearchState<AlgoliaProduct>,
  filterKey: string
): Partial<RangeFilterValue> => {
  if (filterKey === 'percent_cbd' || filterKey === 'percent_thc') {
    const activeRange = searchState.rangeFilters?.[filterKey];
    return { ...activeRange };
  } else {
    return {};
  }
};
